import { computed, ComputedRef, ref, Ref } from "vue";
import type { BaseInputAffix } from "@/src/design_system/form_elements/base_input/types";
import type { DSSelectProps } from "@/src/design_system/form_elements/select/types/props";
import { getExpandIcon } from "@/src/design_system/shared/utils/expand";

interface UseSelectPopover {
  isOpen: Ref<boolean>;
  suffix: ComputedRef<BaseInputAffix>;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useSelectPopover = (props: ComputedRef<Readonly<DSSelectProps>>): UseSelectPopover => {
  const isOpen = ref(false);

  const open = () => {
    if (props.value.disabled) return;
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    if (props.value.disabled) return;
    isOpen.value = !isOpen.value;
  };

  const suffix = computed<BaseInputAffix>(() => ({
    icon: getExpandIcon(isOpen.value),
  }));

  return {
    isOpen,
    suffix,
    open,
    close,
    toggle,
  };
};
